import { DateTimeFormats, TimeSpan } from './types';
import dayjs from 'dayjs';

export const getDaysDiff = (date: string): number => {
  const date1 = new Date(new Date().setHours(0, 0, 0, 0));
  const date2 = new Date(date);
  const difference_In_Time = date1.getTime() - date2.getTime();

  const difference_In_Days = difference_In_Time / (1000 * 3600 * 24);
  return difference_In_Days;
};

export type DateValue = dayjs.ConfigType;

export const formatDate = (value: DateValue, format = DateTimeFormats.Date, defaultValue: string = ''): string => {
  if (dayjs.isDayjs(value)) {
    return value.format(format);
  }

  const date = dayjs(value);

  if (date.isValid()) {
    return date.format(format);
  }

  return defaultValue;
};

export const formatTimeSpan = (time: TimeSpan | null | undefined, showSeconds = false): string => {
  if (!time) return '';

  const hours = time.hours.toString().padStart(2, '0');
  const minutes = time.minutes.toString().padStart(2, '0');
  const seconds = showSeconds && time.seconds !== undefined ? `:${time.seconds.toString().padStart(2, '0')}` : '';

  return `${hours}:${minutes}${seconds}`;
};
